import React from 'react';
import styles from './skeleton.module.scss';

interface SkeletonProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  variant?: 'text' | 'circular' | 'rectangular';
  animation?: 'shimmer' | 'pulse' | 'none';
  className?: string;
  style?: React.CSSProperties;
}

const Skeleton: React.FC<SkeletonProps> = ({
  width,
  height,
  borderRadius,
  variant = 'text',
  animation = 'shimmer',
  className = '',
  style = {},
}) => {
  const combinedStyle: React.CSSProperties = {
    width: width,
    height: height,
    borderRadius: borderRadius,
    ...style,
  };

  return (
    <div
      className={`${styles.skeleton} ${styles[variant]} ${styles[animation]} ${className}`}
      style={combinedStyle}
    />
  );
};

export default Skeleton;
